// RMI-2026-591 (react-refresh/only-export-components): split out of
// AppDataContext.jsx, which now exports only the AppDataProvider component.
import { createContext, useContext } from 'react';

export const AppDataContext = createContext();

export const useAppData = () => {
  const context = useContext(AppDataContext);
  if (!context) {
    throw new Error('useAppData must be used within an AppDataProvider');
  }
  return context;
};
